<template>
  <div class="schedule">
    <div class="time-container" v-for="(time, startTime) in times">
      <time class="time-start" :datetime="$moment(startTime).format('YYYY-MM-DDThh:mm:ss')">
        <span class="time" v-text="$moment(startTime).format('h:mma')"></span>
        <span class="date" v-text="$moment(startTime).format('YYYY-MM-DD')"></span>
      </time>
      <h3 v-text="time.show.title" class="show-title"></h3>
      <img v-if="time.show.image_url" :src="time.show.image_url" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'UpcomingShows',
  data(){
    return {
      times: {}
    }
  },
  async created(){
    try {
      const response = await axios.get('https://wowd-studio.creek.fm/api/times/test1')
      this.times = response.data
    }catch(error){
      console.log(error)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .schedule 
    .time-container
      display inline-block
      padding 20px
      margin 0 20px 20px 0
      border 2px solid #000
      box-shadow 0 2px 2px rgba(0,0,0,0.2)
      
      .time
        margin-right 10px
        font-weight 600
        opacity 0.8
      .date
        opacity 0.6
      

</style>
